export const GET_DISCUSSIONS_REQUEST = 'GET_DISCUSSIONS_REQUEST';
export const GET_DISCUSSIONS_SUCCESS = 'GET_DISCUSSIONS_SUCCESS';
export const GET_DISCUSSIONS_FAILURE = 'GET_DISCUSSIONS_FAILURE';

export const ADD_DISCUSSIONS_REQUEST = 'ADD_DISCUSSIONS_REQUEST';
export const ADD_DISCUSSIONS_SUCCESS = 'ADD_DISCUSSIONS_SUCCESS';
export const ADD_DISCUSSIONS_FAILURE = 'ADD_DISCUSSIONS_FAILURE';

export const ADD_COMMENTS_REQUEST = 'ADD_COMMENTS_REQUEST';
export const ADD_COMMENTS_SUCCESS = 'ADD_COMMENTS_SUCCESS';
export const ADD_COMMENTS_FAILURE = 'ADD_COMMENTS_FAILURE';



export const CHANGE_COUNTRY = 'CHANGE_COUNTRY';
